const fixture = {
    quantity: 1,
    itemsAvailable: 5,
    handleChange: (value: number) => alert(`Changed value = ${value}`)
};

export default fixture;
